<script lang="ts">
  import { cn } from "@/helpers/tw-utils";
  import { typographyVariants, type Props, variantAs } from ".";

  type $$Props = Props;

  interface Props_1 {
    class?: $$Props["class"];
    variant?: $$Props["variant"];
    color?: $$Props["color"];
    weight?: $$Props["weight"];
    as?: string;
    font?: $$Props["font"];
    children?: import('svelte').Snippet;
    [key: string]: any
  }

  let {
    class: className = undefined,
    variant = "p",
    color = "default",
    weight = "default",
    as = variant ? variantAs[variant] : "p",
    font = "poppins",
    children,
    ...rest
  }: Props_1 = $props();
  
</script>

<svelte:element
  this={as}
  class={cn(typographyVariants({ variant, color, weight, font, className }))}
  {...rest}>
  {#if children}
    {@render children()}
  {/if}
</svelte:element>